package com.crowpay.views.components.nav

import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.models.Dimension
import com.lightningkite.kiteui.models.minus
import com.lightningkite.kiteui.models.plus
import com.lightningkite.kiteui.reactive.AppState
import com.lightningkite.kiteui.reactive.ImmediateReadable
import com.lightningkite.kiteui.reactive.Property
import com.lightningkite.kiteui.reactive.lens

data class CrowPayDimensions(
    val xlTitleTextSize:Dimension,
    val titleTextSize:Dimension,

    val subtitleTextSize:Dimension,
    val bodyTextSize:Dimension,
    val smallBodyTextSize:Dimension,

    val fullIndent:Dimension,
    val sectionIndent:Dimension,
    val backgroundIndent:Dimension,

    val majorColumnSpacing:Dimension,

    val tabSectionPadding:Dimension,
    val projectInfoTabsSize:Dimension,
    val activityTabMinSize:Dimension,

    val navMenuWidth:Dimension,

    val pageWidth:Dimension,
    val wideCollapseWidth:Dimension,
    val normalCollapseWidth:Dimension,
    val thinCollapseWidth:Dimension,

    val buttonRowSpacing:Dimension,
    val buttonSpacing:Dimension,
    val buttonHorizontalSpacing:Dimension,
    val buttonMinimumWidth:Dimension,

    val expandButtonSpace:Dimension,

    val labelSpacing:Dimension,

    val outlineWidth:Dimension,
    val cornerRadii:Dimension,

    val largeImagePreview:Dimension,
    val smallImagePreview:Dimension,

    val leftNavWidth:Dimension,
    val topNavHeight:Dimension,

    val actionBarHeight:Dimension
) {
    companion object {
        val rerenderWidth = 55.rem

        val live: ImmediateReadable<CrowPayDimensions> = AppState.windowInfo.lens {
            if (it.width >= rerenderWidth) wideDimensions else narrowDimensions
        }
    }

    val rerenderWidth get() = Companion.rerenderWidth
}


private const val scaleFactor = 0.8

private val wideDimensions = run {
    val fullIndent = 4.rem * scaleFactor
    val sectionIndent = 2.rem * scaleFactor
    val pageWidth = 65.rem

    CrowPayDimensions(
        xlTitleTextSize = 1.6.rem,
        titleTextSize = 1.3.rem,
        subtitleTextSize = 1.1.rem,
        bodyTextSize = 0.9.rem,
        smallBodyTextSize = 0.75.rem,
        fullIndent = fullIndent,
        sectionIndent = sectionIndent,
        backgroundIndent = (fullIndent - sectionIndent) * scaleFactor,
        majorColumnSpacing = 3.rem * scaleFactor,
        tabSectionPadding = 0.5.rem,
        projectInfoTabsSize = 25.rem,
        activityTabMinSize = 25.rem,
        navMenuWidth = 15.rem,
        pageWidth = pageWidth,
        wideCollapseWidth = pageWidth + (12.rem),
        normalCollapseWidth = pageWidth,
        thinCollapseWidth = pageWidth - (17.rem * scaleFactor),
        buttonRowSpacing = 0.7.rem,
        buttonSpacing = 10.dp * scaleFactor,
        buttonHorizontalSpacing = 22.dp * scaleFactor,
        buttonMinimumWidth = 100.dp * scaleFactor,
        expandButtonSpace = 5.dp * scaleFactor,
        labelSpacing = 5.dp,
        outlineWidth = 1.px,
        cornerRadii = 3.dp * scaleFactor,
        largeImagePreview = 15.rem * scaleFactor,
        smallImagePreview = 10.rem * scaleFactor,
        leftNavWidth = 10.rem * scaleFactor,
        topNavHeight = 7.rem * scaleFactor,
        actionBarHeight = 4.5.rem * scaleFactor,
    )
}

private val narrowDimensions = run {
    val fullIndent = 1.rem
    val sectionIndent = 1.rem
    val pageWidth = 45.rem

    CrowPayDimensions(
        xlTitleTextSize = 1.75.rem,
        titleTextSize = 1.3.rem,
        subtitleTextSize = 1.1.rem,
        bodyTextSize = 0.9.rem,
        smallBodyTextSize = 0.75.rem,
        fullIndent = fullIndent,
        sectionIndent = sectionIndent,
        backgroundIndent = fullIndent - sectionIndent,
        majorColumnSpacing = 1.5.rem,
        tabSectionPadding = 0.5.rem,
        projectInfoTabsSize = 25.rem,
        activityTabMinSize = 25.rem,
        navMenuWidth = 15.rem,
        pageWidth = pageWidth,
        wideCollapseWidth = pageWidth + 55.rem,
        normalCollapseWidth = pageWidth + 35.rem,
        thinCollapseWidth = pageWidth,
        buttonRowSpacing = 0.5.rem,
        buttonSpacing = 10.dp * scaleFactor,
        buttonHorizontalSpacing = 22.dp * scaleFactor,
        buttonMinimumWidth = 100.dp * scaleFactor,
        expandButtonSpace = 4.dp,
        labelSpacing = 5.dp,
        outlineWidth = 2.dp,
        cornerRadii = 3.dp,
        largeImagePreview = 8.5.rem,
        smallImagePreview = 5.rem,
        leftNavWidth = 13.rem,
        topNavHeight = 7.rem,
        actionBarHeight = 4.5.rem,
    )
}

val AppDimensions: CrowPayDimensions get() = CrowPayDimensions.live.value